<template>
  <div class="search-page">
    <div class="page-header">
      <woot-button
        icon="chevron-left"
        variant="smooth"
        size="small "
        class="back-button"
        @click="onBack"
      >
        {{ $t('GENERAL_SETTINGS.BACK') }}
      </woot-button>
    </div>
    <section class="search-root">
      <header>        
        <search-tabs          
          :tabs="tabs"
          :selected-tab="activeTabIndex"
          @tab-change="tab => (selectedTab = tab)"
        />
      </header>
      <div class="search-results">        
        <search-tab-contacts v-show="filterContacts"/>
        <search-tab-messages v-if="canShowFilterMessages" v-show="filterMessages"/>
        <search-tab-conversations v-show="filterConversations"/>
        <search-tab-internal-chat v-if="canShowInternalChat" v-show="filterInternalChat"/>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SearchHeader from './SearchHeader.vue';
import SearchTabs from './SearchTabs.vue';
import SearchTabConversations from './SearchTabConversations.vue';
import SearchTabMessages from './SearchTabMessages.vue';
import SearchTabContacts from './SearchTabContacts.vue';
import SearchTabInternalChat from './SearchTabInternalChat.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

import { mixin as clickaway } from 'vue-clickaway';

export default {
  components: {
    SearchHeader,
    SearchTabs,
    SearchTabContacts,
    SearchTabConversations,
    SearchTabMessages,
    SearchTabInternalChat,
  },
  mixins: [clickaway],
  data() {
    return {
      selectedTab: 'contacts',
    };
  },

  computed: {
    ...mapGetters({
      typeAccount: 'getCurrentTypeAccount',
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
    }),
    filterContacts() {
      return this.selectedTab === 'contacts';
    },
    filterConversations() {
      return this.selectedTab === 'conversations';
    },
    filterMessages() {
      return this.selectedTab === 'messages';
    },
    filterInternalChat() {
      return this.selectedTab === 'internal_chat';
    },
    tabs() {
      const tabs = [
        {
          key: 'contacts',
          name: this.$t('SEARCH.TABS.CONTACTS'),
        },
        {
          key: 'conversations',
          name: this.$t('SEARCH.TABS.CONVERSATIONS'),
        },
      ];
      const tabsWithMessages = this.canShowFilterMessages
        ? [...tabs, { key: 'messages', name: this.$t('SEARCH.TABS.MESSAGES') }]
        : tabs;
      return this.canShowInternalChat
        ? [
            ...tabsWithMessages,
            { key: 'internal_chat', name: this.$t('SEARCH.TABS.INTERNAL_CHAT') },
          ]
        : tabsWithMessages;
    },
    activeTabIndex() {
      const index = this.tabs.findIndex(tab => tab.key === this.selectedTab);
      return index >= 0 ? index : 0;
    },
    canShowFilterMessages(){
      return this.typeAccount !== 'parent_account';
    },
    canShowInternalChat() {
      return this.isFeatureEnabledonAccount(this.accountId, FEATURE_FLAGS.INTERNAL_CHAT);
    },
  },
  methods: {    
    onBack() {
      if (window.history.length > 2) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'home' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-page {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.page-header {
  display: flex;
  padding: var(--space-normal);
}
.search-root {
  margin: 0 auto;
  max-width: 90%;
  min-height: 32rem;
  width: 100%;
  height: 100%;
  padding: var(--space-normal);
  display: flex;
  position: relative;
  flex-direction: column;
  background: white;
  margin-top: var(--space-medium);

  .search-results {
    flex-grow: 1;
    height: 100%;
    overflow-y: auto;
    padding: 0 var(--space-small);
  }
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-medium) var(--space-normal);
  border-radius: var(--border-radius-medium);
  margin-top: var(--space-large);
  .icon {
    color: var(--s-500);
  }
  .empty-state__text {
    text-align: center;
    color: var(--s-500);
    margin: var(--space-small);
  }
}
</style>

<style lang="scss">
  .search-page{
    .ve-table .ve-table-header-th .ve-table-sort{
      visibility: hidden;
    }
  }
</style>